export const COMMUNITIES = [
  {
    id: 1,
    name: 'GOOGLE\nDEVELOPER\nGROUPS',
    icon: '/gdglogo.jpg',
    description: 'Community for developers passionate about Google technologies',
    url: 'https://gdg.lucknow.dev',
    buttonText: 'VISIT GDG →'
  },
  {
    id: 2,
    name: 'AI\nCOMMUNITY\nLUCKNOW',
    icon: '/aicommunitylko.png',
    description: 'Exploring AI/ML with TensorFlow and cutting-edge research',
    url: 'https://aicommunity.lucknow.dev/',
    buttonText: 'VISIT AI COMMUNITY LKO →'
  },
  {
    id: 3,
    name: 'LUCKNOW\nAI\nLABS',
    icon: '/lucknowailabs.png',
    description: 'Advancing AI research and applications in Lucknow',
    url: 'https://lucknowai.github.io/',
    buttonText: 'VISIT LAI →'
  }
];

export const CAMPUSES = [
  {
    id: 1,
    name: 'Babu Banarasi Das Institute of Tech & Mgmt',
    full: 'BBD City, Faizabad Road, Lucknow – 226028, Uttar Pradesh, India',
    icon: '/bbditm.png',
    url: 'https://gdg.community.dev/gdg-on-campus-babu-banarasi-das-institute-of-technology-and-management-lucknow-india/'
  },
  {
    id: 2,
    name: 'Shri Ramswaroop Memorial College of Engg & Mgmt',
    full: 'Tiwariganj, Faizabad Road, Lucknow – 226028, Uttar Pradesh, India',
    icon: '/srmcem.png',
    url: 'https://gdg.community.dev/gdg-on-campus-shri-ramswaroop-memorial-college-of-engineering-and-management-lucknow-india/'
  },
  {
    id: 3,
    name: 'Indian Institute of Information Technology, Lucknow',
    full: 'Chak Ganjaria, C.G. City, Lucknow – 226002, Uttar Pradesh, India',
    icon: '/iiit.jpg',
    url: 'https://gdg.community.dev/gdg-on-campus-indian-institute-of-information-technology-lucknow-india/'
  },
  {
    id: 4,
    name: 'Integral University Lucknow',
    full: 'Dasauli, Bas-ha Kursi Road, Lucknow – 226026, Uttar Pradesh, India',
    icon: '/integral.jpeg',
    url: 'https://gdg.community.dev/gdg-on-campus-integral-university-lucknow-india/'
  },
  {
    id: 5,
    name: 'Bansal Institute of Engg & Tech',
    full: 'NH-24, Sitapur Road (Behind Sewa Hospital), Lucknow – 226002/226021, Uttar Pradesh, India',
    icon: '/biet.jpeg',
    url: 'https://gdg.community.dev/gdg-on-campus-bansal-institute-of-engineering-technology-lucknow-india/'
  },
  {
    id: 6,
    name: 'BN College of Engg & Tech',
    full: 'NH-24, Sitapur Road, Bakshi Ka Talab, Lucknow, Uttar Pradesh, India',
    icon: '/bncet.jpg',
    url: 'https://gdg.community.dev/gdg-on-campus-bn-college-of-engineering-technology-lucknow-india/'
  },
  {
    id: 7,
    name: 'Babu Banarasi Das Northern India Institute of Technology',
    full: '11, Faizabad Rd, Atif Vihar, Lucknow, Uattardhona, Uttar Pradesh, India',
    icon: '/bbditm.png',
    url: 'https://gdg.community.dev/gdg-on-campus-babu-banarasi-das-northern-india-institute-of-technology-lucknow-india/'
  }
];

export const EVENT_TYPES = [
  {
    id: 1,
    image: '/genai-hackathon-2025.jpg',
    category: 'Hackathon',
    title: 'GenAI Hackathon\nLucknow 2025',
    location: 'Lucknow',
    dateInfo: '6th November 2025',
    description:
      'Biggest multi-location hackathon in Lucknow till now | 250+ participants | 5 themes | 6 hours of challenge | Mentoring by professionals | 1 big celebration along with some surprises',
    tags: ['AI/ML', 'GenAI', 'Web', 'BuildWithAI', 'Google Cloud'],
    registerLink:
      'https://www.commudle.com/communities/317/hackathons/genai-hackathon-lucknow/fill-form/65',
    badge: 'LIVE NOW',
  }
];

export const FEATURED_EVENT_TAGS = [
  '🤖 AI/ML',
  '☁️ CLOUD',
  '📱 MOBILE',
  '🌐 WEB'
];

export const SOCIAL_LINKS = [
  { icon: 'fab fa-twitter', url: 'https://x.com/gdglko' },
  { icon: 'fab fa-whatsapp', url: 'https://chat.whatsapp.com/L5VMIIEiUz90gh5gcOC054?mode=wwt' },
  { icon: 'fab fa-linkedin', url: 'https://www.linkedin.com/company/google-developer-groups-lucknow' },
  { icon: 'fab fa-instagram', url: 'https://www.instagram.com/gdglucknow/' }
];

export const NAV_LINKS = [
  { name: 'HOME', href: '#home' },
  { name: 'EVENTS', href: '#events' },
  { name: 'COMMUNITIES', href: '#communities' }
];

export const STATS = [
  { number: '100+', label: 'DEVELOPERS', type: 'stat-primary' },
  { number: '30+', label: 'EVENTS', type: 'stat-secondary' },
  { number: '6+', label: 'CAMPUSES', type: 'stat-tertiary' },
  { number: '10,000+', label: 'COMMUNITY MEMBERS', type: 'stat-primary' }
];
